import {
  LOAD_PROFILE,
  LOAD_INSTAGRAM,
  LOAD_PAGE,
} from './constants';

export function loadProfile(influencer){
  return {
    type: LOAD_PROFILE,
    influencer,
  };
};

export function loadInstagram(instagramFeed){
  return {
    type: LOAD_INSTAGRAM,
    instagramFeed
  };
};

export function loadPage(){
  return {
    type: LOAD_PAGE,
  };
};



// WEBPACK FOOTER //
// ./src/containers/profile/actions.js